import { logisticsAsset, medicalPatient, medicalWaste } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '자리에 앉기 위해 고민하거나, 들어갈 때 불을 켜야 하거나, 에어컨을 개인 취향에 맞게 조절해야 하는 일상을 상상해 본 적이 있나요? 이는 먼 미래의 일이 아니라 바로 스마트 오피스가 우리에게 제공하는 현실입니다. 이 글에서는 스마트 오피스가 무엇인지, 그 놀라운 이점, 그리고 기술이 우리의 업무 방식을 어떻게 변화시키고 있는지 설명하겠습니다. 함께 탐험 해보세요!',
  keywords: '스마트 오피스, Smart Office, RTLS, 자산 관리',
  ogSite: '스마트 오피스 (Smart Office)란? 미래의 업무 공간 탐험',
  title: '스마트 오피스 (Smart Office)란? 미래의 업무 공간 탐험',
  ogUrl: 'https://orbro.io/blog/smart-office',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_FNcsD3Sm58vKskOSAzPggZkVSNx0nXt_K62IaFE9_3g5vKuRhrAx1QmbYOkSDElbrPZmfLL5tzO0Gd_vWKDvAxf7q1wJ-SILXZGiUBumlN3EOi-S6lZ_EelCA_-1cg9YeqCbx05iPaeexgKWz-mUbx9dN6MypLUZzgkAFmn48L1ttbu7Zjm8kzkhwYYHT-DQeisNzgQ1SihJvruppUwjmoyz5EFsy0Zc76w-IWkW1BfzyRsB4IsE3sEr39x5HeMJmHdBhqFuyLgWOKBhxiS702j5G-1k1uKmeslDi7t8U42Y-dgc96IA7CPPpXAdSZfI1Nh4s0gJ_Af8PwfH_dFkS89z2cZAnqqGqwFdKu4SQ7yu854HnR8aQG_xNaJ7Wb7A06hCNDQAFt0DDouNEvQYPQBjHJezDFeAjcn10F7pLe-_2a_FJISpPvA3KBHzus4BYfMrNKsnnlDCRH0PY3aYNFSHdWkfNnvWpm51JjBzTZW24Xuu50HvewuucxKU84jkjtkQSGlmR-rLqFzt3CxpwwA_wnDfRSlVLS-i7ZZ3VjIJFkv7o_YPcOlE75HzTwcs2xRmXgSp6d_cAA2iH9hl5Saitrw4z4k7rBne0K8TLIQtHZ_CVHn5yXi6F2HzK6x5RgcZLVP6KXXalV5a0TKUy49l2zWVM2MlcD6tzY1syECdqu_ge15N2_2YGjN1ShMCc_pHgpr0jqpGG5OIL487x-CzV43bYlKLlv6HlIRoBgErdudgextZ5Tesxcam2VEU9wPSnuJQESK49XUrRZuhFfhTQBLNVKFWnROKBGhSdW5wnG26HaGK76EFdo_8ujSIjy4A3Vq3MSuhH1_QV61Em8Gdd5PGMyurwyDOwOepBLoVo5lOn4Fk5qfeoXVXeVV1in3HGHa18IaIfuP_pDvwgkBrdmMgSGOjQnKocTxQ03smWohFNu3Z6gxJmcp0F7ivJeVSSAX2QfJgHSAwlbJcdxOBye3HEkrE0dcvV4iH0hM0UFbh13_90UdK4tcsu61YogN_rTKDhGb9XaW4Z_SCogIenQCdIZwlVD6MbU9p0pJYcWIqWE_vqEjt47q4NFDfwSUcaArB7Oqi6PZCfP3b0UUiCEe-o2iw6HlmAZmmGrDsc3hIoJT3R1L_MVXd1oJLY2ftZ_n8O5dUHHsapct0J4jNlHuOhsDydaAx3-udtvWepJF0XEa-GHXVIm2bcjjzFzBwixHADIli93jW1kVYfgMNgGs77eozsaHKsm5EDoZ3D2mLfW8UXILFzzonNGNkDzBsU0J6RxtO14z_-_PxrihgogkVwsAIKICe_FI0p7vZ-6FTRwc51zmwy0pEkz_H2EAD0nslvowAzY5e5ujuqc1Lay862dr3YPqOKybeBOns_rhp9guWW2gYTxLLtGyMNn29GjTFeFuRr1HPlpcsSxhimaefvpIPllAqzIIReQhz-sf8SBbaQR5ioeVhADZol666lfTyTVoPl2ax9iyV22WX8rkh4KJG0EvGgawVqWe7nyhWXgl4t1tLf-3Gxp4tD94YKJwp36Urlsbf2AnbXdyi5aI4wY9qtvgt3lCXt9MGZ3f4VIcucMMLmzMtTU7Pod3xzV_yQS6ttSIV9Ncq0KaWxA-p_20eRG=w1418-h1412?auditContext=prefetch',
  ogType: 'website',
  date: '2025-07-09',
  tag1: '#스마트오피스',
  tag2: '#SmartOffice',
  tag3: '#RTLS',
  tag4: '#자산관리',
  text: [
    {
      head: '',
      subHead: '',
      desc: '자리에 앉기 위해 고민하거나, 들어갈 때 불을 켜야 하거나, 에어컨을 개인 취향에 맞게 조절해야 하는 일상을 상상해 본 적이 있나요? 이는 먼 미래의 일이 아니라 바로 스마트 오피스가 우리에게 제공하는 현실입니다. 이 글에서는 스마트 오피스가 무엇인지, 그 놀라운 이점, 그리고 기술이 우리의 업무 방식을 어떻게 변화시키고 있는지 설명하겠습니다. 함께 탐험 해보세요!',
      dot: ''
    },
    {
      head: '1. 스마트 오피스 (Smart Office)란?',
      subHead: '',
      desc: '스마트 오피스는 사물인터넷(IoT), 인공지능(AI), 자동화와 같은 첨단 기술을 통합하여 유연하고 효율적이며 사용자 친화적인 업무 환경을 만드는 공간입니다. 단순히 일하는 장소가 아니라, 스마트 오피스는 생산성을 최적화하고 에너지를 절약하며 직원들의 경험을 향상시키는 기술 생태계입니다.\n\n간단히 말해, 스마트 오피스는 조명, 온도, 책상, 회의실 등 모든 것이 사용자의 요구에 맞춰 \'알고\' \'반응\'하는 곳으로, 사소한 일에 신경 쓰지 않고 업무에 집중할 수 있게 해줍니다.\n\n예시: 오피스에 들어서면 얼굴 인식 시스템이 자동으로 로그인하고, 조명과 에어컨이 개인 취향에 맞게 조절되며, 휴대폰 터치 한 lần으로 회의실을 예약할 수 있습니다.',
      dot: ''
    },
    {
      head: '2. 스마트 오피스 (Smart Office)의 이점',
      subHead: '',
      desc: '스마트 오피스는 단순한 트렌드가 아니라 기업과 직원 모두에게 실질적인 이점을 제공합니다.\n\n• 업무 생산성 향상\n개인화된 업무 환경은 직원들이 더 편안하고 집중할 수 있게 합니다.\n예시: 스마트 책상은 앉은 자세에 맞게 높이를 자동으로 조절하여 피로를 줄이고 업무 효율을 높입니다.\n\n• 운영 비용 절감\n자동화 시스템은 전기, 물 사용을 줄이고 공간 활용을 최적화합니다.\n예시: 사람이 없는 구역의 조명이 자동으로 꺼져 월간 전기 비용을 30% 절감할 수 있습니다.\n\n• 직원 경험 개선\n직원들은 모바일 앱을 통해 자리 예약, 회의실 예약, 업무 환경 조정을 쉽게 할 수 있습니다.\n예시: 직원은 사무실에 오기 전에 앱을 통해 창가 자리나 동료 근처 자리를 선택할 수 있습니다.\n\n• 보안 및 안전 강화\n스마트 카메라와 센서가 이상 징후를 감지하여 직원과 자산의 안전을 보장합니다.\n예시: 얼굴 인식 카메라는 권한이 있는 직원만 민감한 구역에 들어갈 수 있도록 합니다.\n\n• 유연한 업무 지원\n스마트 오피스는 하이브리드 업무 모델(사무실과 재택 근무의 결합)에 쉽게 적응합니다.\n예시: 직원들은 원격으로 회의실이나 책상을 예약할 수 있어 공간을 효율적으로 관리할 수 있습니다.',
      dot: ''
    },
    {
      head: '3. 스마트 오피스 (Smart Office)에 사용되는 기술',
      subHead: '',
      desc: '스마트 오피스를 만들기 위해 다음과 같은 핵심 기술이 사용됩니다.\n\n• 사물인터넷(IoT)\nIoT 센서는 조명, 온도, 공간 사용 데이터를 수집하여 환경을 자동으로 조절합니다.\n예시: 움직임 센서가 사람이 방에 들어오면 불을 켜고, 나가면 끕니다.\n\n• 인공지능(AI)\nAI는 데이터를 분석하여 공간 사용需求을 예측하고, 회의 일정을 최적화하거나 환경 조정을 제안합니다.\n예시: AI는 팀원들의 일정을 기반으로 적절한 회의 시간을 제안합니다.\n\n• 자동화\n조명, 에어컨, 블라인드와 같은 장치가 수동 개입 없이 자동으로 조절됩니다.\n예시: 햇빛이 너무 강하면 블라인드가 자동으로 닫혀 사무실을 시원하게 유지합니다.\n\n• 실시간 위치 추적 시스템(RTLS)\n사무실 내 직원과 자산의 위치를 추적하여 공간 관리와 보안을 강화합니다.\n예시: 직원들은 모바일 앱을 통해 동료나 장비의 위치를 찾을 수 있습니다.\n\n• 모바일 앱\n직원들이 원격으로 업무 공간을 제어하고 알림을 받을 수 있게 합니다.\n예시: 사무실에 오기 전에 앱을 통해 책상이나 회의실을 예약할 수 있습니다.',
      dot: ''
    },
    {
      head: '4. 스마트 오피스 (Smart Office)의 실제 사례',
      subHead: '',
      desc: '스마트 오피스는 전 세계적으로 도입되고 있으며, 인상적인 결과를 보여주고 있습니다.\n\n• Viettel Tower (하노이): IoT 시스템을 활용해 에너지 관리로 연간 전기 비용을 20% 절감했습니다.\n\n• The Edge (암스테르담): 세계에서 가장 스마트한 오피스로 여겨지며, 28,000개의 센서가 조명, 온도, 업무 공간을 제어합니다.\n\n• Googleplex (미국): AI를 활용해 공간을 최적화하고 직원들이 더 효율적으로 일할 수 있도록 지원합니다.\n\n베트남 사례: 호치민의 한 기술 회사는 자동 예약 시스템을 갖춘 스마트 오피스를 도입하여 하이브리드 모델에서 직원들이 업무 공간을 쉽게 관리할 수 있게 했습니다.',
      dot: ''
    },
    {
      head: '5. 스마트 오피스 (Smart Office)의 미래',
      subHead: '',
      desc: '기술의 발전으로 스마트 오피스는 더욱 지능적으로 진화할 것입니다.\n\n• 고급 AI: 직원의 요구를 더 정확하게 예측하고 환경을 자동으로 조절합니다.\n\n• 스마트 홈과의 통합: 직원들이 스마트 홈 생태계의 일부로 원격에서 오피스를 제어할 수 있습니다.\n\n• 지속 가능성: 재생 에너지와 친환경 기술을 활용해 환경 영향을 줄입니다.\n\n예시: 미래의 스마트 오피스는 직원의 기분에 따라 조명과 온도를 조절하여 생산성과 만족도를 높일 수 있습니다.',
      dot: ''
    },
    {
      head: '6. 결론',
      subHead: '',
      desc: '스마트 오피스는 단순한 트렌드가 아니라 편리함, 효율성, 지속 가능성을 제공하는 미래의 업무 공간입니다. 생산성 향상, 비용 절감, 직원 경험 개선 등 스마트 오피스는 우리의 업무 방식을 변화시키고 있습니다. 이 기술에 대해 더 알고 싶으신가요? 스마트 오피스 솔루션 제공업체에 문의하여 오늘 바로 업무 공간을 혁신하는 여정을 시작하세요!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: medicalPatient.thumb,
        data: 'medicalPatient',
        link: '/enterprise/medical/patient',
      },
      {
        img: medicalWaste.thumb,
        data: 'medicalWaste',
        link: '/enterprise/medical/waste',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/enterprise/logistics/asset',
      },
    ],
  },
};
